module.exports = __webpack_public_path__ + "img/head-banner3.212b6665.jpg";